import Http from "../http";

class NearByServices{
    static async getAllNearyIndex(){
        return Http.get('/nearbyIndex');
    }
    static async editNearyIndex(id,data){
        return Http.update(`/nearbyIndex/${id}`,data);
    }
    static async getNearyIndexById(id){
        return Http.get(`/nearbyIndex/${id}`);
    }
    static async deleteNearyIndexById(id){
        return Http.delete(`/nearbyIndex/${id}`)
    }
    static async addNearyByIndex(data){
        return Http.post('/nearbyIndex',data);
    }

}
export default NearByServices